import Vue from 'vue'
import config from '@/config/index'

const state = {
  provinceList: []
}

const getters = {
  tambonItems: (state) => (id) => {
    let p = state.provinceList.find( p => p.districts.find( d => d.id === id) )
    if(p){
      let targetd = p.districts.find(o => o.id === id)
      if(targetd){
        return targetd.tambons
      }
    }
    return []
  },
  districtItems: (state) => (id) => {
    let p = state.provinceList.find( p => p.id === id )
    if(p){
      return p.districts.map( d => {
          return { id: d.id, tname: d.tname}
      })
    }
    return []
  },
  provinceItems: (state) => {
    if(state.provinceList){
      return state.provinceList.map( p => {
        return {id: p.id, tname: p.tname}
      })
    } else {
      return []
    }
  }
}

const mutations = {
  setProvinceList (state, payload) {
    state.provinceList = payload
  }
}

const actions = {
  fetchProvinces ({ commit, dispatch }) {
    return Vue.axios.get(`${config.serverURI}/provinces/deep`).then((response) => {
      commit('setProvinceList', response.data)
      return Promise.resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/address.js